<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { PercentageInput } from '@fire-calc/ui-vue';
import { useCalculatorStore } from '../state/calculatorStore';

const store = useCalculatorStore();
const { scenario } = storeToRefs(store);

const annualReturn = computed(() => scenario.value.annualReturn.asPercent);
const inflation = computed(() => scenario.value.inflation.asPercent);
const swr = computed(() => scenario.value.swr.asPercent);
</script>

<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-lg w-full">
    <PercentageInput
      :model-value="inflation"
      :label="$t('labelInflation')"
      @update:model-value="(v: number) => store.updateInflation(v / 100)"
    />
    <PercentageInput
      :model-value="swr"
      :label="$t('labelSWR')"
      @update:model-value="(v: number) => store.updateSwr(v / 100)"
    />
    <PercentageInput
      :model-value="annualReturn"
      :label="$t('labelAnnualReturn')"
      @update:model-value="(v: number) => store.updateAnnualReturn(v / 100)"
    />
  </div>
</template>